import type { ProductRoot } from '@/components/ProductFullDetail-new/types/product';
import useIsMobile from '@/hooks/use-is-mobile';
import { getMediaGalleryEntries } from '@/util/productFullDetailUtil';
import { useMemo } from 'react';
import { isCustomizeDressAttribute } from '../isCustomizeDressAttribute';
import type { OptionsSelectionsMap } from '../lib/get-optionSelections';
import { useProductFullDetailStore } from '../store/use-product-full-detail-store';

export const useGetMediaGalleryEntries = ({
  product,
  optionSelections,
}: {
  product: ProductRoot;
  optionSelections: OptionsSelectionsMap;
}) => {
  const hasCustomizeDressAttribute =
    product.ampProtOption?.items?.findIndex(temp => isCustomizeDressAttribute(temp.label)) > -1;

  const customizeDressImages: Array<any> = [];

  if (hasCustomizeDressAttribute) {
    // 有礼服定制属性，图片地址需要拼接
    const attributes = product.ampProtOption.items;

    const path: Array<string> = [];

    let selectedColor;

    attributes.forEach(temp => {
      if (temp.label.toLowerCase().indexOf('color') > -1) {
        // 获取选中的颜色
        const values = temp.values;

        const selectedValue = values.find(temp => optionSelections.get(temp.option_id.toString()) === temp.value_index);

        if (selectedValue) {
          selectedColor = selectedValue;
        }
      } else if (temp.label === 'Fabric' || isCustomizeDressAttribute(temp.label)) {
        const values = temp.values;
        const selectedValue = values.find(temp => optionSelections.get(temp.option_id.toString()) === temp.value_index);

        if (selectedValue) {
          if (isCustomizeDressAttribute(temp.label)) {
            path.push(selectedValue.label.split(' ').join('-'));
          } else {
            path.push(selectedValue.label);
          }
        }
      }
    });

    if (selectedColor) {
      // 加上颜色

      const firstImage =
        '/product_image/' +
        product.sku +
        '/' +
        path.join('/') +
        '/' +
        selectedColor.label.split(' ').join('-') +
        '(1)-watermark.webp';

      const secondImage =
        '/product_image/' +
        product.sku +
        '/' +
        path.join('/') +
        '/' +
        selectedColor.label.split(' ').join('-') +
        '(2)-watermark.webp';

      customizeDressImages.push({
        file: firstImage,
        image: '',
        label: 'Image',
        thumbnail: '',
        url: '',
      });

      customizeDressImages.push({
        file: secondImage,
        image: '',
        label: 'Image',
        thumbnail: '',
        url: '',
      });
    }
  }

  const optionCodes = useProductFullDetailStore(state => state.getOptionCode(product));

  const isMobile = useIsMobile();

  const mediaGalleryEntries = useMemo(
    () => getMediaGalleryEntries(product, optionCodes, optionSelections, isMobile),
    [product, optionCodes, optionSelections, isMobile],
  );

  return {
    mediaGalleryEntries: hasCustomizeDressAttribute ? customizeDressImages : mediaGalleryEntries,
  };
};
